<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  @if (prevModel()) {
    <span class="fw-bold"
      >{{ 'admin.grid.clientSelected' | translate }}
      {{ prevModel().name }}</span
    >
  }
  <div formArrayName="countryAssignments">
    <gstar-countries-combobox
      [title]="'admin.grid.searchCountry' | translate"
      (selectCountry)="countrySelect($event)" />
    @for (assignment of countryAssignments.controls; track $index) {
      <div class="ap-mb-spacing-4 d-flex" [class.mt-3]="$index === 0">
        <ap-field [hidden]="true">
          <input appkit-field [formControlName]="$index" />
        </ap-field>
        <div class="me-auto">
          <div class="d-flex align-items-center">
            <ap-avatar
              diameter="40"
              borderWidth="0"
              [name]="assignment.value?.name?.charAt(0) ?? ''"
              [disabled]="true"></ap-avatar>
            <span class="ap-ml-spacing-4">
              {{ assignment.value?.name ?? '' }}
            </span>
          </div>
        </div>
        <div>
          <button
            (click)="removeAssignment($index)"
            class="Appkit4-icon icon-delete-outline">
            &nbsp;
          </button>
        </div>
      </div>
    }
  </div>
</form>
